@if (show()) {
  <div
    class="pa-brief-page"
    data-testid="pa-daily-briefing"
    [@.disabled]="reduceMotion"
    @pageFade>
    <div class="pa-brief" @contentRise>
      <div class="pa-brief__greeting">
        <h1 class="pa-brief__hello">
          {{ greeting() }}{{ name() ? ', ' + name() : '' }}.
        </h1>
        <p class="pa-brief__lede">Let's plan your session.</p>
        @if (orgName()) {
          <aiomed-pa-org-picker variant="pill" />
        }
        <div class="pa-brief__divider" aria-hidden="true"></div>
      </div>

      <section class="pa-brief__card">
        <h2 class="pa-brief__card-h">How much time do you have today?</h2>
        <p class="pa-brief__card-sub">
          Your plan fills in priority order to fit your time.
        </p>
        <aiomed-pa-time-picker
          variant="card"
          [value]="timeMode.value()"
          (valueChange)="onTime($event)" />
      </section>

      <div class="pa-brief__actions">
        <button type="button" class="pa-brief__skip" (click)="skip()">
          <i class="ph ph-arrow-right" aria-hidden="true"></i> Skip for now
        </button>
        <button type="button" class="pa-brief__cta" (click)="seePlan()">
          See my plan <i class="ph ph-arrow-right" aria-hidden="true"></i>
        </button>
      </div>

      <div class="pa-brief__foot">
        Skipping uses your full working day by default. You can change this
        anytime from Home.
      </div>
    </div>
  </div>
}
